// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appProjects/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appProjects/getData', async (params, { dispatch, getState }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/Projects/List', {params})
  dispatch(setLoading({getData: false}))
  return {
    params,
    data: response.data
  }
})

export const appProjectsSlice = createSlice({
  name: 'appProjects',
  initialState: {
    data: [],
    totalRecords: 1,
    params: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appProjectsSlice.reducer
